// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/components/conversationitem/index.scss
// module id = 2366
// module chunks = 13